import { render, staticRenderFns } from "./attestation.vue?vue&type=template&id=3ad77c00"
import script from "./attestation.vue?vue&type=script&lang=js"
export * from "./attestation.vue?vue&type=script&lang=js"
import style0 from "./attestation.vue?vue&type=style&index=0&id=3ad77c00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports